module.exports = __webpack_public_path__ + "img/viva-lbl.41ba3eab.png";